import { hashToNumber } from '@shared/utils/strings';
import ColorConstants from '@shared/constants/ColorConstants';

const funColors = [
    ColorConstants.FUN_ORANGE,
    ColorConstants.FUN_GRAPE_DARK,
    ColorConstants.FUN_GRAPE_LIGHT,
    ColorConstants.FUN_GREEN,
    ColorConstants.FUN_PINK,
    ColorConstants.FUN_LAVANDER_DARK,
    ColorConstants.FUN_BLUE,
];

export const chooseColor = (key: string) => {
    const colorAmount = funColors.length;
    const hash = hashToNumber(key);

    return funColors[hash % colorAmount];
};
